import './ProjectedCashFlow.scss';
import React, {useEffect} from 'react';
import {getPershingJWT, resetBrokerageMFE} from "services/Rest";
import { compose } from "redux";
import { connect } from "react-redux";
import {getBrokerageMFELogin, getBrokerageMFEState} from "state/brokerage/BrokerageSelectors";
import Store from "state/Store";
import {receivedBrokerageLogin, updateBrokerageMFEState} from "state/brokerage/BrokerageActions";
import {getCustomerWebView, getLdapId} from "state/customer/CustomerSelectors";
import AAMFooterContainer from "../Footer/FooterUtil";
import { mapProductTypeToiiFooterBoolean } from "state/account/AccountSelectors";
import { isMobile } from "state/view/ViewSelectors";
import { hasAppLoaded } from "state/analytics/analyticsSelectors";
import ErrorPage from "components/shared/ErrorPage/ErrorPage";
import PageLoadingSpinner from "components/layouts/Navigation/PageLoadingSpinner";
import LegalReferenceNumber from "../LegalReferenceNumber/LegalReferenceNumber";
import {legalReferenceNumbers} from "services/Content";
import { MFE_STATE } from "support/BrokerageMFEUtils";

const ProjectedCashFlow = ({
                             mfeLoggedIn,
                             ldapId,
                             isMobileApp,
                             footerProductTypes,
                             appLoaded,
                             isCustomerWebView,
                             MFEState,
                           }) => {
  useEffect(() => {
    resetBrokerageMFE();
  }, []);

  const handleEvents = (event) => {
    if (event.msgid === 'PERMFE003') {
      // successful login
      Store.dispatch(receivedBrokerageLogin(true));
    }
    // Renew token event
    if (event.msgid === 'PERMFE007') {
      getPershingJWT(true, ldapId);
    }
    // Login Error
    if (event.msgid === 'PERMFE004') {
      Store.dispatch(updateBrokerageMFEState(MFE_STATE.ERROR));
    }
    //MFE Loading event
    if (event.msgid === 'PERMFE011') {
      if (event.text.includes('Loaded Module @pershing/nxi-ng-account')) {
        Store.dispatch(updateBrokerageMFEState(MFE_STATE.LOADED));
        // Setting the MFE to default to a specific account
        const search = window.location?.search || '';
        const results = /id=([A-Za-z0-9]*)/g.exec(search);
        if (results) {
          setTimeout(() => {
            window.pershingMFEHelper.setAccount(results[1]);
          });
        }
      }
    }
  }

  useEffect(() => {
    if (window && window.pershingMFEHelper && ldapId) {
      window.pershingMFEHelper.getPershingMFEEvents(handleEvents);
      if (mfeLoggedIn) {
        // Load the required MFE Modules form pershing
        window.pershingMFEHelper.loadModules(["nxi-ng-account", "nxi-ng-pcf"]);
      } else {
        //Get the JWT token from the Pershing API
        getPershingJWT(false, ldapId);
      }
    }
  }, [mfeLoggedIn, ldapId]);
  return MFEState === MFE_STATE.ERROR
    ? <ErrorPage />
    : MFEState === MFE_STATE.LOADING
      ? <PageLoadingSpinner name="Projected Cash Flow"/>
      : (
        <div className="beacon-on-darker projected-cash-flow-wrapper">
          <div className="pcf-header-container">
            <div className="temp b-typography-serif--headline--600 b-font-weight-bold">
              Projected Cash Flow
            </div>
          </div>
          <div className="pcf-mfe-wrapper">
            <div className="per-mfe-ns blocked_data">
              <account-dropdown-app
                className="per-mfe-ns"
                ishouseholdpage="false"
                ismanagedaccountspage="false"
                showsingleaccounts={isCustomerWebView}
                pageid="PCF"
              ></account-dropdown-app>
              <div>
                <income-cash-filter-wrapper-app></income-cash-filter-wrapper-app>
              </div>
              <div className="pcf-mfe-graph-container">
                <income-cash-bar-graph-app></income-cash-bar-graph-app >
              </div>
              <div>
                <income-cash-pcf-app></income-cash-pcf-app >
                <div className="pcf-mfe-extra-footer">
                  Projected cash flow only includes brokerage accounts.
                </div>
              </div>
            </div>
          </div>
          <div className="preferences-lrn-layout-footer">
            <LegalReferenceNumber
              providedLegalNumber={legalReferenceNumbers.PCF_MFE}
            />
          </div>
          <AAMFooterContainer
            isMobileParam={isMobileApp}
            footerProductTypes={footerProductTypes}
            appLoaded={appLoaded}
          />
        </div>
  )
};

const mapStateToProps = (state) => ({
  appLoaded: hasAppLoaded(state),
  footerProductTypes: mapProductTypeToiiFooterBoolean(state),
  isMobileApp: isMobile(state),
  mfeLoggedIn: getBrokerageMFELogin(state),
  ldapId: getLdapId(state),
  isCustomerWebView: getCustomerWebView(state),
  MFEState: getBrokerageMFEState(state)
});
export default compose(
  connect(mapStateToProps)
)(ProjectedCashFlow);